import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PortalAuthenticationService } from '@service/b2b-portal/portal-authentication/portal-authentication.service';
import { ToastService } from '@shared/service/toast.service';
import { clearSession, getSession } from '@shared/utils/session.util';

/**
 * Guard to protect routes that require an active 2FA session.
 * Checks for the existence of a valid 2FA token in session storage.
 * Redirects to /login and clears session if token is not found.
 */
export const b2b2FaSessionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const portalAuthenticationService = inject(PortalAuthenticationService);
  const toastService = inject(ToastService);

  const twoFaSessionData = portalAuthenticationService.get2FaSessionData();

  if (!twoFaSessionData?.token2fa) {
    clearSession();
    router.navigate(['/login']);
    toastService.showError(
      'Session abgelaufen, bitte melden Sie sich erneut an.'
    );
    return false;
  }

  return true;
};
